document.addEventListener('DOMContentLoaded', () => {
  const page = document.querySelector('.template-page-artists #MainContent');
  if (!page) return;

  const gridSections = [...page.querySelectorAll('.shopify-section:has(.multicolumn)')];
  const signatureSection = gridSections.find((section) =>
    section.querySelector('.multicolumn__title')?.textContent.includes('SIGNATURE ARTISTS')
  );
  const directorySection = gridSections.find((section) =>
    section.querySelector('.multicolumn__title')?.textContent.includes('ENDORSED ARTISTS')
  );

  gridSections.forEach((section) => section.classList.add('artists-grid-section'));
  signatureSection?.classList.add('artists-signature');
  directorySection?.classList.add('artists-directory');

  page.querySelectorAll('.multicolumn-list__item').forEach((card) => {
    const title = card.querySelector('.multicolumn-card__info h3')?.textContent.trim();
    const cardLink = card.querySelector('.multicolumn-card-link');
    if (title && cardLink) cardLink.setAttribute('aria-label', `View ${title}`);
  });

  if (!directorySection) return;

  const heading = directorySection.querySelector('.multicolumn__title');
  const grid = directorySection.querySelector('.multicolumn-list');
  const cards = [...directorySection.querySelectorAll('.multicolumn-list__item:not(.multicolumn-list__item--empty)')];
  if (!heading || !grid || !cards.length) return;

  for (let index = cards.length - 1; index > 0; index -= 1) {
    const randomIndex = Math.floor(Math.random() * (index + 1));
    [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
  }
  cards.forEach((card) => grid.appendChild(card));

  const tools = document.createElement('div');
  tools.className = 'artists-directory-tools';
  tools.innerHTML = `
    <div class="artists-directory-search">
      <label for="ArtistDirectorySearch">Find an artist or band</label>
      <input
        id="ArtistDirectorySearch"
        type="search"
        placeholder="Search the artist roster"
        autocomplete="off"
      >
    </div>
    <p class="artists-directory-count" aria-live="polite"></p>
  `;
  heading.after(tools);

  const input = tools.querySelector('input');
  const count = tools.querySelector('.artists-directory-count');
  const empty = document.createElement('p');
  empty.className = 'artists-directory-empty';
  empty.textContent = 'No artists match that search.';
  empty.hidden = true;
  grid.appendChild(empty);

  const updateDirectory = () => {
    const query = input.value.trim().toLocaleLowerCase();
    let visible = 0;

    cards.forEach((card) => {
      const matches = !query || card.textContent.toLocaleLowerCase().includes(query);
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    count.textContent = `${visible} ${visible === 1 ? 'artist' : 'artists'}`;
    empty.hidden = visible !== 0;
  };

  input.addEventListener('input', updateDirectory);
  updateDirectory();
});
